import { Box, Typography } from '@mui/material'
import React from 'react'

interface CourseDescriptionPreviewProps {
	courseDetails?: {
		description: string;
	};
}

export const CourseDescriptionPreview = ({ courseDetails }: CourseDescriptionPreviewProps) => {
	if (courseDetails?.description === null || courseDetails?.description === undefined || courseDetails?.description === '') {
		return null
	}
	
	return (
		<Box>
			<Typography
				sx={{
					fontSize: '24px',
					fontWeight: 800,
					color: '#000',
					marginTop: '64px',
					marginBottom: '14px'
				}}
			>
				Описание курса
			</Typography>
			<Typography
				sx={{
					fontSize: '18px',
					fontWeight: 400,
					marginBottom: '16px',
					color: '#808992'
				}}
			>{courseDetails.description}</Typography>
		</Box>
	)
}